module.exports = __webpack_public_path__ + "img/us.aefba3fe.svg";